import "./home.scss";

const UserDeletion = () => {
    return (
        <div className="home-page-container ph-10 pt-20">
            <div className="home-page-body">
                <h1 className="pb-20">User Deletion Instruction</h1>
                <h3 className="pb-20">Effective as of January 2022</h3>
                <div className="policy">
                    <p>
                        At any time, user decides to stop using our service or app, he/she can make a request to
                        remove his/her personal information such as name, username, phone, address, email, and profile
                        pictures.
                    </p>
                    <p>
                        User can click on username on the upper right corner and select <b>"Your Profiles"</b>. Then click on
                        <b>"Request User Deletion"</b> button. Our team will work on your request ASAP.
                    </p>
                    <p> You may cancel your request in the same place if your request isn't successfully proceeded.</p>
                    <p>
                        After successful deletion, user can still reuse our service or app; however, all the previous transactions
                        such as customer orders, invoices, payments, requests/chat will be no longer available.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default UserDeletion;